import IndigoServiceClient from 'communication/IndigoServiceClient';
import { ApiRequestOptions } from 'communication/ApiCallInfo';
import IndigoApiError from 'communication/IndigoApiError';
import { EstimatedTradeCostApiRequest } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiRequest';
import { EstimatedTradeCostApiResponse } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiResponse';

export async function callTradeOptimizer(
    indigoServiceClient: IndigoServiceClient,
    request: EstimatedTradeCostApiRequest,
    options: ApiRequestOptions
): Promise<EstimatedTradeCostApiResponse> {
    const url = 'alice/optimizer';

    return await IndigoApiError.runHandlingErrorsAsync(
        `Trade Optimizer`,
        async () => {
            return await indigoServiceClient.post(url, request, options);
        }
    );
}
